const onlineDepositRouter = [
	{
		path: '/onlineDeposit',
		name: 'OnlineDeposit',
		component: () => import('@/views/onlineDeposit')
	},
	{
		path: '/onlineDeposit/otherHouseDeposit',
		name: 'OtherHouseDeposit',
		component: () => import('@/views/onlineDeposit/OtherHouseDeposit')
	},
	{
		path: '/onlineDeposit/signUserMessage',
		name: 'SignUserMessage',
		component: () => import('@/views/onlineDeposit/SignUserMessage')
	},
	{
		path: '/onlineDeposit/depositMessage',
		name: 'DepositMessage',
		component: () => import('@/views/onlineDeposit/DepositMessage')
	},
	{
		path: '/onlineDeposit/depAgreeList',
		name: 'DepAgreeList',
		component: () => import('@/views/onlineDeposit/DepAgreeList')
	},
	{
		path: '/onlineDeposit/signChild/signSuccess',
		name: 'SignSuccess',
		component: () => import('@/views/onlineDeposit/signChild/SignSuccess')
	},
	{
		path: '/onlineDeposit/signChild/waitSign',
		name: 'WaitSign',
		component: () => import('@/views/onlineDeposit/signChild/WaitSign')
	},
	{
		path: '/onlineDeposit/signChild/signFail',
		name: 'SignFail',
		component: () => import('@/views/onlineDeposit/signChild/SignFail')
	},
	{
		path: '/onlineDeposit/billSignObtain/billSignObtain',
		name: 'BillSignList',
		component: () => import('@/views/onlineDeposit/billSignObtain/BillSignList')
	},
]
export default onlineDepositRouter
